var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.33334V5.4C3 5 3.26667 4.73334 3.66667 4.73334H12.3333C12.7333 4.73334 13 5 13 5.4V10.9333C13 11.3333 12.7333 11.6 12.3333 11.6H3.66667C3.26667 11.6 3 11.3333 3 10.9333",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 8.57142L12.4666 5.17142C12.6666 5.03809 12.5332 4.77142 12.3332 4.77142H3.66657C3.46657 4.77142 3.3999 5.03809 3.53324 5.17142L7.9999 8.57142Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2002 8.46667H4.4002",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1333 9.79999H4.39997",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmail);
export default __webpack_public_path__ + "static/media/sendmail.c37539237aa9f51ed2f3c81f138f1098.svg";
export { ForwardRef as ReactComponent };